import React, { ReactNode } from 'react';
import { useInvoicesContext } from './InvoicesContext';
import NoInvoicesImage from 'assets/no_invoices.svg';
import { NoItemsPlaceholder } from 'components';

export const NoInvoicesWrapper = ({ children }: { children: ReactNode }) => {
  const { invoices, invoicesLoading, filtersApplied } = useInvoicesContext();

  if (invoicesLoading || filtersApplied || invoices.length > 0) return <>{children}</>;

  return (
    <NoItemsPlaceholder image={NoInvoicesImage} imageAlt="No invoices" title="Du hast noch keine Rechnung erhalten" />
  );
};
